<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><a id="pg5">CONTENTS</a></p><a id="pg5">
</a><p class="toc"><a id="pg5"></a><a href="#/preface">Preface</a></p>
<p class="toc1"><a href="#/chapter01">1. Cold War Origins</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">2. Operation Rollback: Insurrection Behind the Iron Curtain</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">3. The Day Under Communism: Mosinee on May 1, 1950</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">4. Joseph McCarthy: Hero or Pariah?</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">5. The Sky Is Falling: Sputnik IV Crashes in Wisconsin</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">6. Nuclear Missiles in Wisconsin: Project Nike</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">7. Cold War Casualties: Bombers Crash While Training Over Wisconsin Airspace</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">8. A Soviet Princess Takes Refuge in Wisconsin</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">9. USS <i>Pueblo</i>: A Small Kewaunee Ship Impounded in North Korea</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10. Stasi Prisoners in Our Midst</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11. A Safe House in Milwaukee</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">12. Cold War Personalities</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">13. Terror in Madison: Sterling Hall Explosion</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">14. Military Bases in Wisconsin during the Cold War</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">15. Legacy of the Cold War</span></p>
<p class="toc1"><span href="#/epilog" title="Link target outside of Sample">Epilogue. The Cold War Abroad:<br/>Visiting Cold War “Battlefields”</span></p>
<p class="toc"><span href="#/note" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e251a35c